// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyAYFO_EDNtLZNg7oujPu4CSRLeCF9szxXk",
	authDomain: "u-2-write-63ba7.firebaseapp.com",
	projectId: "u-2-write-63ba7",
	storageBucket: "u-2-write-63ba7.appspot.com",
	messagingSenderId: "750358823607",
	appId: "1:750358823607:web:9ae3fd3d7a2f5bf9320332",
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
export default firebase
